export class AbortVideoRequestModel {
  /**ID видео */
  VideoId!: string;
  /**ID файла */
  FileId!: number;

  constructor(obj?: Partial<AbortVideoRequestModel>) {
    Object.assign(this, obj);
  }
}
